import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import moment from "moment";

import {
  TaskSummaryChart,
  PnLSummaryChart,
  MonthlyIncomeExpenseChart,
  DelayedProjectsCard,
  DailyTransactionsCard,
  ProjectSummaryChart,
  CategorySummaryChart,
  BalanceSummaryChart,
} from "../../components/dashboard-pro";
import { DateRangeInput, PageHeader } from "../../components/v3";
import {
  VIEW_PRO_BALANCE_AND_ADVANCE_SUMMARY,
  VIEW_PRO_PROJECT_SUMMARY,
  VIEW_PRO_EXPENSE_SUMMARY,
  VIEW_PRO_PNL_SUMMARY,
  VIEW_PRO_DAILY_TRANSACTIONS,
  VIEW_PRO_DELAYED_PROJECTS,
  VIEW_PRO_MONTHLY_INCOME_EXPENSE,
  VIEW_PRO_TASK_SUMMARY,
} from "../../constants/permissions";
import { PageLayout } from "../../layouts/PageLayout";
import { useHasPermission } from "../../utils";

export function DashboardPro() {
  const hasViewBalanceAndAdvanceSummary = useHasPermission(VIEW_PRO_BALANCE_AND_ADVANCE_SUMMARY);
  const hasViewProjectSummary = useHasPermission(VIEW_PRO_PROJECT_SUMMARY);
  const hasViewExpenseSummary = useHasPermission(VIEW_PRO_EXPENSE_SUMMARY);
  const hasViewPnLSummary = useHasPermission(VIEW_PRO_PNL_SUMMARY);
  const hasViewDailyTransactions = useHasPermission(VIEW_PRO_DAILY_TRANSACTIONS);
  const hasViewDelayedProjects = useHasPermission(VIEW_PRO_DELAYED_PROJECTS);
  const hasViewMonthlyIncomeExpense = useHasPermission(VIEW_PRO_MONTHLY_INCOME_EXPENSE);
  const hasViewTaskSummary = useHasPermission(VIEW_PRO_TASK_SUMMARY);

  const [dateRange, setDateRange] = useState({
    startDate: moment().subtract(1, "year").startOf("day").toISOString(),
    endDate: moment().add(1, "year").endOf("day").toISOString(),
  });

  const handleDateRangeChange = (ranges) => {
    const selection = ranges?.[0];
    if (!selection?.startDate || !selection?.endDate) return;

    setDateRange({
      startDate: moment(selection.startDate).startOf("day").toISOString(),
      endDate: moment(selection.endDate).endOf("day").toISOString(),
    });
  };

  return (
    <PageLayout>
      {/* header section */}
      <PageHeader
        title="Dashboard"
        customElement={
          <DateRangeInput
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            onDateRangeChange={handleDateRangeChange}
            style={{
              width: 220,
              "& .MuiOutlinedInput-root": {
                color: "#fff",
                "& fieldset": { borderColor: "#fff" },
                "&:hover fieldset": { borderColor: "#fff" },
                "&.Mui-focused fieldset": { borderColor: "#fff" },
              },
              "& .MuiInputBase-input": {
                color: "#fff",
              },
              "& .MuiSvgIcon-root": {
                color: "#fff",
              },
            }}
          />
        }
      />

      {/* card section */}
      <Row
        className="mb-4"
        style={{
          marginTop: "-90px",
          position: "relative",
          zIndex: 2,
          marginLeft: 0,
          marginRight: 0,
          paddingLeft: "10px",
          paddingRight: "10px",
        }}
      >
        {hasViewBalanceAndAdvanceSummary && (
          <Col xs={12}>
            <BalanceSummaryChart />
          </Col>
        )}
      </Row>

      <Row
        style={{
          marginLeft: 0,
          marginRight: 0,
          paddingLeft: "10px",
          paddingRight: "10px",
          paddingBottom: "24px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {hasViewProjectSummary && (
          <Col xs={12} xl={8} className="mb-4 mb-xl-0">
            <ProjectSummaryChart fromDate={dateRange.startDate} toDate={dateRange.endDate} />
          </Col>
        )}
        {hasViewExpenseSummary && (
          <Col xs={12} xl={4}>
            <CategorySummaryChart fromDate={dateRange.startDate} toDate={dateRange.endDate} />
          </Col>
        )}
      </Row>
      {/* P&L Summary */}
      {hasViewPnLSummary && (
        <Row
          style={{
            marginLeft: 0,
            marginRight: 0,
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingBottom: "24px",
            position: "relative",
            zIndex: 2,
          }}
        >
          <Col xs={12}>
            <PnLSummaryChart fromDate={dateRange.startDate} toDate={dateRange.endDate} />
          </Col>
        </Row>
      )}
      <Row
        style={{
          marginLeft: 0,
          marginRight: 0,
          paddingLeft: "10px",
          paddingRight: "10px",
          paddingBottom: "24px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {hasViewDailyTransactions && (
          <Col xs={12} xl={8}>
            <DailyTransactionsCard />
          </Col>
        )}
        {hasViewDelayedProjects && (
          <Col xs={12} xl={4} className="mb-4 mb-xl-0">
            <DelayedProjectsCard />
          </Col>
        )}
      </Row>

      <Row
        style={{
          marginLeft: 0,
          marginRight: 0,
          paddingLeft: "10px",
          paddingRight: "10px",
          paddingBottom: "24px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {hasViewMonthlyIncomeExpense && (
          <Col xs={12} xl={7}>
            <MonthlyIncomeExpenseChart />
          </Col>
        )}

        {hasViewTaskSummary && (
          <Col xs={12} xl={5} className="mb-4 mb-xl-0">
            <TaskSummaryChart />
          </Col>
        )}
      </Row>
    </PageLayout>
  );
}
